<template>
  <div>
    <survey-info v-if="!surveyIndex || !surveyIndex.surveyInfoRead" />
    <award :survey="survey" v-else-if="showAward" />
    <survey :survey="survey" v-else @finished="finished()" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Award from '@/components/surveys/Award.vue'
import Survey from '@/components/surveys/Survey.vue'
import SurveyInfo from '@/components/surveys/SurveyInfo.vue'

export default {
  data() {
    return {
      showAward: false
    }
  },
  components: {
    Award,
    Survey,
    SurveyInfo
  },
  computed: {
    survey() {
      return this.surveys.filter(s => s.id == this.$route.params.id)[0]
    },
    ...mapState('surveys', {
      surveys: state => state.list,
      surveyIndex: state => state.index
    }),
  },
  methods: {
    finished() {
      this.showAward = true
    }
  }
}
</script>

<style>

</style>